var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1653.99,
    height: 288,
    viewBox: "0 0 1653.99 288",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1d1d1b;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40,127.4A142.06,142.06,0,0,1,92.2,75.2Q125.2,56,164.8,56q50,0,94,32l-22,34q-17.61-12.81-34.8-18.8a112.22,112.22,0,0,0-37.2-6,97.55,97.55,0,0,0-50.6,13.6A99.31,99.31,0,0,0,77.8,148a103.38,103.38,0,0,0-13.4,52,103.44,103.44,0,0,0,13.4,52,99.46,99.46,0,0,0,36.4,37.2,97.64,97.64,0,0,0,50.6,13.6q44.79,0,72-26.8l22.4,33.2a129.79,129.79,0,0,1-42.8,25.6,147.3,147.3,0,0,1-51.6,9.2q-39.6,0-72.6-19.2A142.06,142.06,0,0,1,40,272.6q-19.2-33-19.2-72.6T40,127.4Z",
    transform: "translate(-20.8 -56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M519.6,60V340H476.4V214.8h-126V340H307.2V60h43.2V173.2h126V60Z",
    transform: "translate(-20.8 -56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M747,68.4a98.84,98.84,0,0,1,41.8,36.8q15.6,24.39,15.6,58.8V340H762V314.8Q731.59,344,686.39,344q-35.21,0-60.8-14t-38.8-37.2a104.35,104.35,0,0,1,0-101.6Q600,168,625.59,154t60.8-14q47.6,0,75.6,28v-4q0-20-10-34.6a65.17,65.17,0,0,0-26.6-22.4A82.23,82.23,0,0,0,690,99.2a177.25,177.25,0,0,0-39.4,4.8q-21,4.8-34.6,12.4L596.39,80q17.21-10.41,42-17.2A194,194,0,0,1,690,56,131.51,131.51,0,0,1,747,68.4ZM726.19,294q17.4-9.21,26.6-22.6t9.2-25.8v-7.2q-6-24-26.4-40.8t-49.2-16.8q-30,0-49.6,17T617.19,242q0,27.19,19.6,44.2t49.6,17Q708.79,303.2,726.19,294Z",
    transform: "translate(-20.8 -56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1031,69.2a90,90,0,0,1,37,37q12.79,23.79,12.8,55.8V340H1038V174q0-36-17.4-56.6t-46.2-20.6a61.56,61.56,0,0,0-31,8.6q-15,8.59-24.6,25.4t-9.6,40V340h-42.8V60h42.8V84Q934,56,974.39,56,1006.79,56,1031,69.2Z",
    transform: "translate(-20.8 -56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1373.59,314.8a146.62,146.62,0,0,1-41.8,21.6q-23,7.59-56.2,7.6-43.2,0-76.4-19.2a134.57,134.57,0,0,1-51.4-52q-18.21-32.81-18.2-72.8,0-39.6,18.6-72.6a137.57,137.57,0,0,1,51.6-52.2q33-19.2,74.6-19.2,52.8,0,96.8,33.6l-22.8,32.8q-31.61-24.81-74-24.8-27.6,0-50.4,12.8a91.6,91.6,0,0,0-35.8,36.2q-13,23.4-13,53.4,0,30.39,12.4,53.6a86.74,86.74,0,0,0,35.2,35.8q22.8,12.6,52.8,12.6t54.8-10.4v-72h-49.2l2.8-42h89.6Z",
    transform: "translate(-20.8 -56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1608.39,77.4q32.4,17.4,49.4,49t17,73.6q0,42-17,73.6t-49.4,49Q1576,340,1530.79,340h-97.2V60h97.2Q1576,60,1608.39,77.4Zm-3.2,194.8q26-26.2,26-72.2t-26-72.2q-26-26.2-71.6-26.2h-56.8V298.4h56.8Q1579.19,298.4,1605.19,272.2Z",
    transform: "translate(-20.8 -56)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoText);
export default __webpack_public_path__ + "static/media/logo-text.fe8e443ef79ca7b8079361f26216beef.svg";
export { ForwardRef as ReactComponent };